export default __webpack_public_path__ + "static/FReg-Schools-00e3c453bd1349afc0d34245182224b6.jpg";